import React, {useState} from "react";
import "./UserDashboardCard.scss"
import {
    convertCurrencyFormatPositiveNegative,
} from "@moeindal/base-raiko-panel-components";

export default function UserDashboardCard({title = "روزانه", number = 0, colorKey = 0}) {

    const backgrounds = [
        "backgroundColorSky100",
        "backgroundColorCyan100",
        "backgroundColorBlue100",
        "backgroundColorIndigo100",
        "backgroundColorViolet100",
        "backgroundColorPurple100",
        "backgroundColorEmerald100"
    ]


    return (
        <div className={`userDashboardCardLayout ${backgrounds[colorKey % 7]}`}>
            <div className={"userDashboardCardInfoContainer"}>
                <span className={"userDashboardCardTitle"}>{title}</span>
                <span
                    className={"userDashboardCardNumber"}>
                    {
                        number === 0 ?
                            "0" :
                            convertCurrencyFormatPositiveNegative(number)
                    }
                </span>
            </div>
            <div className={"userDashboardCardIconContainer"}>
                <div className={"ic-android"}/>
            </div>
        </div>
    )
}